import React from "react";

export default function Section({ id, eyebrow, title, description, children }) {
  return (
    <section
      id={id}
      className="py-14 px-4 sm:px-6 lg:px-8"
    >
      <div className="max-w-6xl mx-auto">
        {(eyebrow || title || description) && (
          <div className="mb-8 space-y-2 text-center">
            {eyebrow && (
              <p className="text-sm uppercase tracking-[0.2em] text-amber-300/80">
                {eyebrow}
              </p>
            )}
            {title && (
              <h2 className="text-3xl md:text-4xl font-extrabold text-white drop-shadow-lg">
                {title}
              </h2>
            )}
            {description && (
              <p className="text-base md:text-lg text-gray-300 max-w-3xl mx-auto">
                {description}
              </p>
            )}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
